import React from "react";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import Header from "./../sharedScreens/Header";

const HotelManualBooking = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Hotel Manual Booking</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Branch "}
                          label="Branch "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Customer Name"}
                          placeholder="Customer Name"
                        />
                      </div>

                    </div>
                  </div>
                </div>

                <div className="card-header text-center">
                  <h3 className="card-title">Hotel Booking Details</h3>
                </div>
                <div className="card card-custom mt-2">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Hotel Name"}
                          placeholder="Hotel Name"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label={"City"} placeholder="City" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label={"Country"} placeholder="Country" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          label="Star Rating"
                          placeholder={"Star Rating*"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"No. of Room"}
                          placeholder="No. of Room"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label={"Check-In"} placeholder="Check-In" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Check-Out "}
                          placeholder="Check-Out  "
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label={"Hotel Info"} placeholder="Country" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Hotel Inclusion*"}
                          placeholder="Hotel Inclusion*"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Hotel Email*"}
                          placeholder="Hotel Email*"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label={"Location"} placeholder="Location" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label={"Address"} placeholder="Address" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Cancellation Policy*"}
                          placeholder="Cancellation Policy*"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Hotel Conf. No.*"}
                          placeholder="Hotel Conf. No.*"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Hotel Ref. No"}
                          placeholder="Hotel Ref. No"
                        />
                      </div>

                    </div>
                  </div>
                </div>


                <div className="card-header text-center">
                  <h3 className="card-title">Hotel Supplier Details</h3>
                </div>
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Booking Supplier "}
                          label="Booking Supplier "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Booking PCC"}
                          placeholder="Booking PCC"
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton className="clear-btn " label="Clear" />
                          <MuiButton
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                            label={"Get"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default HotelManualBooking;
